export const ADDITIONAL_DRIVER = {
    SET_SPOUSE_ADDITIONAL_DRIVER: 'SET_SPOUSE_ADDITIONAL_DRIVER',
};